'use strict';

/**
 * Water Testing Now - Global Theme JavaScript
 * Shopify 2.0 Theme
 */

document.addEventListener('DOMContentLoaded', function () {

  /* ==========================================
     1. Mobile Menu Toggle
     ========================================== */
  const menuToggle = document.querySelector('[data-mobile-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');

  if (menuToggle && mobileMenu) {
    const focusableSelectors = 'a[href], button, input, textarea, select, [tabindex]:not([tabindex="-1"])';

    function openMenu() {
      menuToggle.setAttribute('aria-expanded', 'true');
      mobileMenu.classList.add('is-open');
      document.body.style.overflow = 'hidden';

      const firstFocusable = mobileMenu.querySelector(focusableSelectors);
      if (firstFocusable) firstFocusable.focus();
    }

    function closeMenu() {
      menuToggle.setAttribute('aria-expanded', 'false');
      mobileMenu.classList.remove('is-open');
      document.body.style.overflow = '';
      menuToggle.focus();
    }

    menuToggle.addEventListener('click', function () {
      const isOpen = menuToggle.getAttribute('aria-expanded') === 'true';
      if (isOpen) {
        closeMenu();
      } else {
        openMenu();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && mobileMenu.classList.contains('is-open')) {
        closeMenu();
      }
    });

    // Trap focus within open mobile menu
    mobileMenu.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      if (!mobileMenu.classList.contains('is-open')) return;

      const focusableElements = mobileMenu.querySelectorAll(focusableSelectors);
      if (focusableElements.length === 0) return;

      const firstEl = focusableElements[0];
      const lastEl = focusableElements[focusableElements.length - 1];

      if (e.shiftKey) {
        if (document.activeElement === firstEl) {
          e.preventDefault();
          lastEl.focus();
        }
      } else {
        if (document.activeElement === lastEl) {
          e.preventDefault();
          firstEl.focus();
        }
      }
    });
  }

  /* ==========================================
     2. Sticky Header
     ========================================== */
  const stickyHeader = document.querySelector('[data-sticky-header]');

  if (stickyHeader) {
    let lastKnownScrollY = 0;
    let ticking = false;

    function updateStickyHeader() {
      if (lastKnownScrollY > 100) {
        stickyHeader.classList.add('is-sticky');
      } else {
        stickyHeader.classList.remove('is-sticky');
      }
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      lastKnownScrollY = window.scrollY;
      if (!ticking) {
        requestAnimationFrame(updateStickyHeader);
        ticking = true;
      }
    }, { passive: true });

    // Check initial scroll position on load
    lastKnownScrollY = window.scrollY;
    updateStickyHeader();
  }

  /* ==========================================
     3. Announcement Bar Dismiss
     ========================================== */
  const announcementDismiss = document.querySelector('[data-announcement-dismiss]');
  const announcementBar = announcementDismiss
    ? announcementDismiss.closest('[data-announcement-bar]')
    : null;

  if (announcementBar) {
    // Check if previously dismissed this session
    if (sessionStorage.getItem('announcement-dismissed') === 'true') {
      announcementBar.style.display = 'none';
    }

    announcementDismiss.addEventListener('click', function () {
      announcementBar.style.display = 'none';
      sessionStorage.setItem('announcement-dismissed', 'true');
    });
  }

  /* ==========================================
     4. Cart Count Update
     ========================================== */
  function updateCartCount() {
    fetch('/cart.json', {
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        var cartCountElements = document.querySelectorAll('[data-cart-count]');
        cartCountElements.forEach(function (el) {
          el.textContent = cart.item_count;
          // Toggle visibility if count is zero
          if (cart.item_count > 0) {
            el.removeAttribute('hidden');
          } else {
            el.setAttribute('hidden', '');
          }
        });
      })
      .catch(function (error) {
        console.error('Error fetching cart:', error);
      });
  }

  // Listen for custom cart:updated event
  document.addEventListener('cart:updated', function () {
    updateCartCount();
  });

  // Initial cart count fetch
  updateCartCount();

});
